module.exports = __webpack_public_path__ + "img/subway.5a4505f2.png";